import React, { useState, useEffect, useMemo } from "react";
import {
  Modal,
  Row,
  Col,
  Button,
  Form,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";

import { connect, useSelector } from "react-redux";
import { getPaperWallet, paperDeposit, paperWithdraw } from "../../actions/setting-action";
import Loading from "../common/Loading";
import useInput from "../hooks/useInput";
import { toast } from "react-toastify";
import "./PaperDepositWithdraw.scss";
import { AccountName, AccountType } from "../../Const";

const PaperDepositWithdraw = (props) => {
  const { show, onHide, isDeposit, setIsDeposit, paperDeposit, paperWithdraw,t } =
    props;
  const [loading, setLoading] = useState(false);
  const [amount, bindAmount, resetAmount] = useInput("0");

  const {
    usEquityCoins,
    indiceCoins,
    forexCoins,
    metalCoins,
  } = useSelector((state) => state.settings.paperWallet) || {};
  const [selectedType, setSelectedType] = useState("us_equity");
  const coins =  useMemo(() => {
    return selectedType === AccountType.us_equity
      ? usEquityCoins
      : selectedType === AccountType.forex
      ? forexCoins
      : selectedType === AccountType.indice
      ?indiceCoins
      :metalCoins;
  }, [selectedType])
  const [selectedCoin, setSelectedCoin] = useState("");
  

  useEffect(() => {
    if (coins && coins.length) {
      //console.log(coins[0])
      setSelectedCoin(coins[0].pair.from);
    }
  }, [coins]);
  const coin = useMemo(
    () => coins.find((el) => el.pair.from === selectedCoin),
    [selectedCoin, coins]
  );

  const clickConfirm = () => {
    if (!coin) return;
    if (!isDeposit && coin.free < Number(amount))
      return toast.error("Insufficient balance");
    setLoading(true);
    const paperAction = isDeposit ? paperDeposit : paperWithdraw;
    paperAction({ coin: selectedCoin, amount })
      .then(() => {
        setLoading(false);
        toast.success("Successful" + (isDeposit ? " Deposit" : " Withdrawal"));
        onHide();
        resetAmount();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  };

  const coinItems = coins.map((el) => (
    <Dropdown.Item key={el.pair.from} eventKey={el.pair.from}>
      {" "}
      {el.pair.from}
    </Dropdown.Item>
  ));
  return (
    <Loading show={loading} onHide={() => setLoading(false)}>
      <Modal show={show} onHide={onHide} className="paper-withdraw">
        <Modal.Header closeButton>
          <Modal.Title>{isDeposit ? t("ADD") : t("REDUCE")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ margin: "5px 30px" }}>
            <Row>
              <Col>
                <Button
                  variant={isDeposit ? "primary" : "outline-primary"}
                  onClick={() => setIsDeposit(true)}
                  className="w-100"
                >
                   {t("ADD")}
                </Button>
              </Col>
              <Col>
                <Button
                  variant={isDeposit ? "outline-primary" : "primary"}
                  onClick={() => setIsDeposit(false)}
                  className="w-100"
                >
                 {t("REDUCE")}
                </Button>
              </Col>
            </Row>
            <Col  xs={12} lg={12} className="asset-coins">
              <Row>

              <Form.Label className="bot-asset-tour mt-4">
                    {t("Markets")} 
                  </Form.Label>
              </Row>
                
                  <Form.Group
                    as={Row}
                    className="mt-2"
                    //onChange={(e) => setSelectedType(e.target.value)}
                    onClick={(e) => setSelectedType(e.target.value)}
                  >
                    <Form.Check
                      type="radio"
                      label={AccountName.us_equity}
                      name="filter"
                      value={AccountName.us_equity}
                      className="mr-2"
                      defaultChecked={selectedType==AccountType.us_equity}
                    />
                    <Form.Check
                      type="radio"
                      label={AccountName.forex}
                      name="filter"
                      value={AccountType.forex}
                      className="mr-2"
                      defaultChecked={selectedType==AccountType.forex}
                    />
                    <Form.Check
                      type="radio"
                      label={AccountName.indice}
                      name="filter"
                      value={AccountType.indice}
                      className="mr-2"
                      defaultChecked={selectedType==AccountType.indice}
                    />
                    <Form.Check
                      type="radio"
                      label={AccountName.metal}
                      name="filter"
                      value={AccountType.metal}
                      className="mr-3"
                      defaultChecked={selectedType==AccountType.metal}
                    />
                  </Form.Group>
                </Col>
            <Form.Group className="mt-3">
              <Form.Label>Symbol</Form.Label>
              <DropdownButton
                title={selectedCoin}
                onSelect={(val) => setSelectedCoin(val)}
                variant="outline-secondary"
              >
                {coinItems}
              </DropdownButton>
            </Form.Group>
            <Form.Group className="mt-3 mb-2">
              <Form.Label>{t("amount")}</Form.Label>
              <Form.Control type="number" {...bindAmount} />
            </Form.Group>
            {!isDeposit && (
              <p className="text-right">
                {t("available")}: {coin && coin.free} {selectedCoin}
              </p>
            )}
            <div className="my-3 text-center">
              <Button
                variant="success"
                className="w-100"
                onClick={clickConfirm}
              >
                CONFIRM
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Loading>
  );
};

export default connect(null, { paperDeposit, paperWithdraw })(
  PaperDepositWithdraw
);
